export default __webpack_public_path__ + "static/media/GetHelp_PerApp.04c79fc0.svg";